/**
 * Map a Vue router route name to a search_origin value recognised by the backend.
 * Used to track where a search was initiated (funnel & error analytics).
 */
export const routeNameToSearchOrigin = (routeName) => {
  if (!routeName) return 'other';
  const name = String(routeName).replace(/Locale$/, '');
  if (['Home', 'BasicSearch', 'WeatherSearchPage'].includes(name)) return 'home';
  if (name === 'Results') return 'results';
  if (name === 'WeatherSearch') return 'weather';
  if (name === 'AdPreview' || name === 'Debug') return 'ad_preview';
  return 'other';
};

export const openPendingResultsTab = (enabled) => {
  if (!enabled) return null;

  const resultWindow = window.open('', '_blank');
  if (!resultWindow) return null;

  resultWindow.document.title = 'Browsing flights…';
  resultWindow.document.body.innerHTML = `
    <main style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#f8fafc;font-family:system-ui,-apple-system,sans-serif;color:#334155">
      <div style="display:flex;align-items:center;gap:12px;font-size:18px;font-weight:600">
        <span style="width:20px;height:20px;border:3px solid #bfdbfe;border-top-color:#2563eb;border-radius:9999px;animation:properflight-spin .8s linear infinite"></span>
        Browsing flights…
      </div>
    </main>
    <style>@keyframes properflight-spin{to{transform:rotate(360deg)}}</style>
  `;
  return resultWindow;
};

export const closePendingResultsTab = (resultWindow) => {
  if (resultWindow && !resultWindow.closed) resultWindow.close();
};

export const navigatePendingResultsTab = (resultWindow, href, storage = {}) => {
  if (!resultWindow || resultWindow.closed) return false;

  try {
    Object.entries(storage).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        resultWindow.sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
      }
    });
  } catch (error) {
    console.warn('Could not copy search state to the new results tab:', error);
  }
  resultWindow.location.href = href;
  return true;
};
